import React, { Component } from 'react';
import StepperEvent from './../../../Components/StepperEvent';
import { Card, CardBody, Row, Col, Label } from 'reactstrap';
import { withRouter } from 'react-router-dom';
// import axios from 'axios';

class Status extends Component {
  constructor(props) {
    super(props);
    this.state = {
      DataShipment: props.data,
    };
  }

  render() {
    let { DataShipment } = this.state
    return (

      <Card className='myCard'>
        <Row>
          <Col xs={12}>
            <CardBody style={{ fontSize: '14px', padding: '15px 15px 0px 15px' }}>
              <Label >
                <b>Shipment#  {DataShipment.ShipmentNumber}</b>
              </Label>
              <Label >
                <b>Status</b>
              </Label>
              <Col>
                <Row>
                  {DataShipment.ModoTransporte ? <i className={DataShipment.ModoTransporte === 'AEREA' ? 'fas fa-plane mr-2' : DataShipment.ModoTransporte === 'MARITIMA' ? 'fas fa-ship mr-2' : 'fas fa-truck mr-2'} style={{ fontSize: '1.5em', color: '#656565' }} /> : ''}
                  <Label style={{ fontSize: '13px' }}>
                    <b>{DataShipment.Estatus}</b>
                  </Label>
                </Row>
              </Col>
            </CardBody>
          </Col>
          <Col xs={12}>
            <StepperEvent steps={this.props.steps} />
          </Col>
        </Row>
      </Card>
    );
  }
}

export default withRouter(Status);